import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  Button,
  Typography,
  Checkbox,
  FormGroup,
  TextField,
  Divider,
  Box,
  FormHelperText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import { myWordsQuery } from "../../../../../../validations/myWordsValidation";
import DialogData from "./DialogData";
import GetBankAccounts from "./GetBankAccounts";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CheckoutsQuery(props) {
  const { setQueryCheckoutsListData, getCheckoutsListFromBack } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDialogContent, setOpenDialogContent] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [dialogContentData, setDialogContentData] = React.useState("");

  const [checkout, setCheckout] = React.useState({
    bankCheckoutInfo: "",
    bankCheckoutCardNumber: "",
    transactionId: "",
    amount_start: "",
    amount_end: "",
    checkoutRequestDate_start: "",
    checkoutRequestDate_end: "",
    checkoutDoneDate_start: "",
    checkoutDoneDate_end: "",
    situation: "",
  });

  const handleSetValue = (key, value) => {
    const newValue = {};
    newValue[key] = value;
    setCheckout({ ...checkout, ...newValue });
  };

  const initialValues = {
    bankCheckoutInfo: "",
    transactionId: "",
    amount_start: "",
    amount_end: "",
    checkoutRequestDate_start: "",
    checkoutRequestDate_end: "",
    checkoutDoneDate_start: "",
    checkoutDoneDate_end: "",
    situation: "",
  };

  const onSubmit = (values, props) => {
    let newValues = {
      bankCheckoutInfo: checkout["bankCheckoutInfo"],
      transactionId: values.transactionId,
      amount_start: values.amount_start,
      amount_end: values.amount_end,
      checkoutRequestDate_start: values.checkoutRequestDate_start,
      checkoutRequestDate_end: values.checkoutRequestDate_end,
      checkoutDoneDate_start: values.checkoutDoneDate_start,
      checkoutDoneDate_end: values.checkoutDoneDate_end,
      situation: values.situation,
    };

    for (const property in newValues) {
      if (typeof newValues[property] == "boolean") continue;
      if (!newValues[property]) delete newValues[property];
    }
    setQueryCheckoutsListData(newValues);
    getCheckoutsListFromBack("getCheckoutsList", newValues);
  };

  const handleDateTime = (date, props, Field) => {
    if (!date) {
      props.setFieldValue(Field, "");
    } else {
      date.convert(gregorian);
      let DateForSend = new DateObject({ date, calender: gregorian }).format(
        "YYYY-MM-DD"
      );
      props.setFieldValue(Field, DateForSend);
      date.convert(persian);
    }
  };

  const handleSetBankInfo = (data) => {
    // propsFiled.setFieldValue("bankName", e.target.value);
    setCheckout({ ...checkout, ...data });
  };
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };

  const setDialog = (type) => {
    if (type == "selectBank") {
      setDialogTitle(`انتخاب حساب برای واریز وجه`);
      handleOpenDialogContent();
      setDialogContentData(
        <GetBankAccounts
          handleSetBankInfo={handleSetBankInfo}
          handleCloseDialogContent={handleCloseDialogContent}
        />
      );
    }
  };

  const calenderDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <Box>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
      >
        {dialogContentData}
      </DialogData>

      <Formik
        initialValues={initialValues}
        validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    ></StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"بانک و حساب"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl
                        sx={{
                          display: "inline-flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={() => setDialog("selectBank")}
                        >
                          انتخاب حساب
                        </Button>
                        <Typography sx={{ mx: 1 }}>
                          {`${checkout["bankCheckoutCardNumber"].slice(
                            checkout["bankCheckoutCardNumber"].length - 6,
                            checkout["bankCheckoutCardNumber"].length
                          )} ...`}
                        </Typography>
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="bankCheckoutInfo" />
                        </FormHelperText>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"آی دی رهگیری"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="transactionId"
                        label="آی دی رهگیری "
                        placeholder="آی دی رهگیری "
                        value={checkout.transactionId}
                        onChange={(e) => {
                          props.setFieldValue("transactionId", e.target.value);
                          handleSetValue("transactionId", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="transactionId" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"از مبلغ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="amount_start"
                        label="از مبلغ"
                        placeholder="از مبلغ"
                        value={checkout.amount_start}
                        onChange={(e) => {
                          props.setFieldValue("amount_start", e.target.value);
                          handleSetValue("amount_start", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="amount_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"تا مبلغ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="amount_end"
                        label="تا مبلغ"
                        placeholder="تا مبلغ"
                        value={checkout.amount_end}
                        onChange={(e) => {
                          props.setFieldValue("amount_end", e.target.value);
                          handleSetValue("amount_end", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="amount_end" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ درخواست) از تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(
                            event,
                            props,
                            "checkoutRequestDate_start"
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="checkoutRequestDate_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ درخواست) تا تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(
                            event,
                            props,
                            "checkoutRequestDate_end"
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="checkoutRequestDate_end" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ تسویه) از تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(
                            event,
                            props,
                            "checkoutDoneDate_start"
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="checkoutDoneDate_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ تسویه) تا تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(event, props, "checkoutDoneDate_end");
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="checkoutDoneDate_end" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"وضعیت"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl style={{ minWidth: 120 }}>
                        <InputLabel id="demo-simple-select-label">
                          وضعیت
                        </InputLabel>
                        <Select
                          size="small"
                          label="situation"
                          name="situation"
                          id="situation"
                          value={checkout.situation}
                          onChange={(e) => {
                            handleSetValue("situation", e.target.value);
                            props.setFieldValue("situation", e.target.value);
                          }}
                        >
                          <MenuItem autoFocus key={0} value="">
                            همه
                          </MenuItem>
                          <MenuItem autoFocus key={2} value="pending">
                            در انتظار تسویه
                          </MenuItem>
                          <MenuItem
                            autoFocus
                            key={3}
                            value="awaitingSettlement"
                          >
                            در حال تسویه
                          </MenuItem>
                          <MenuItem autoFocus key={4} value="Done">
                            تسویه شده
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="situation" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              جستجو
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
  // <Box
  //   sx={{
  //     textAlign: "center",
  //     my: 1,
  //   }}
  // >
  //   <FormControl>
  //     {/* <FormLabel id="selectedPackages">پکیج های من</FormLabel> */}
  //     <Typography variant="h6" gutterBottom>
  //       پکیج های من
  //     </Typography>
  //     <RadioGroup
  //       row
  //       aria-labelledby="selectedPackages"
  //       name="selectedPackages"
  //       onChange={handleSelectedPackage}
  //       // value={selectedPackage}
  //     >
  //       <FormControlLabel value="true" control={<Radio />} label="معتبر" />
  //       <FormControlLabel
  //         value="false"
  //         control={<Radio />}
  //         label="غبر معتبر"
  //       />
  //       <FormControlLabel value="all" control={<Radio />} label="همه" />
  //     </RadioGroup>
  //     <Button onClick={clicktoback} variant="contained">مشاهده</Button>
  //   </FormControl>
  // </Box>
  // );
}

const areaCodeList = {
  994: "آذربایجان",
  54: "آرژانتین",
  27: "آفریقای جنوبی",
  236: "آفریقای مرکزی",
  355: "آلبانی",
  49: "آلمان",
  1: "آمریکا",
  244: "آنگولا",
  43: "اتریش",
  251: "اتیوپی",
  375: "بلاروس",
  962: "اردن",
  374: "کد ارمنستان",
  598: "اروگوئه",
  291: "اریتره",
  7371: "ازبکستان",
  34: "اسپانیا",
  61: "کد استرالیا",
  372: "استونی",
  43: "اطریش",
  93: "افغانستان",
  213: "الجزایر",
  503: "السالوادور",
  971: "کد امارات",
  62: "اندونزی",
  44: "کد انگلستان",
  25: "اوگاندا",
  380: "اوکراین",
  39: "ایتالیا",
  98: "ایران",
  353: "ایرلند",
  593: "اکوادور",
  354: "ایسلند",
  18094: "باربادوس",
  18093: "باهاما",
  973: "بحرین",
  55: "برزیل",
  673: "بروئنی",
  32: "بلژیک",
  359: "بلغارستان",
  880: "بنگلادش",
  229: "بنین",
  267: "بوتان",
  387: "بوسنی و هرزگوین",
  591: "بولیوی",
  595: "پاراگوئه",
  507: "پاناما",
  92: "پاکستان",
  351: "پرتغال",
  51: "پرو",
  95: "پنال",
  992: "تاجیکستان",
  255: "تانزانیا",
  66: "تایلند",
  886: "تایوان",
  1868: "ترینیداد",
  7363: "ترکمنستان",
  90: "ترکیه",
  216: "تونس",
  676: "تونگا",
  18099: "جامائیکا",
  359: "جزایر قناری",
  692: "جزایرمارشال",
  237: "چاد",
  86: "چین",
  42: "چک",
  45: "دانمارک",
  1767: "دومینیکا",
  1809: "دومینیکن",
  250: "رو آندا",
  7095: "روسیه",
  40: "رومانی",
  243: "زئیر",
  260: "زامبیا",
  64: "زلاند نو",
  263: "زیمبابوه",
  81: "ژاپن",
  225: "ساحل عاج",
  684: "ساموآ آمریکا",
  685: "ساموا غربی",
  94: "سریلانکا",
  1758: "سنت لوسیا",
  1784: "سنت وینسنت",
  1869: "سنت کیتس",
  65: "سنگاپو",
  221: "سنگال",
  46: "سوئد",
  41: "سوئیس",
  249: "سودان",
  597: "سورینام",
  963: "سوریه",
  252: "سومالی",
  148: "سیشل",
  56: "شیلی",
  381: "صربستان و مونته نگرو",
  966: "کد کشور عربستان",
  964: "عراق",
  968: "عمان",
  233: "غنا",
  33: "فرانسه",
  358: "فنلاند",
  679: "فیجی",
  63: "فیلیپین",
  357: "قبرس",
  7331: "قرقیزستان",
  974: "قطر",
  855: "کامبوج",
  237: "کامرون",
  1: "کانادا",
  82: "کره جنوبی",
  850: "کره شمالی",
  385: "کرواسی",
  506: "کاستاریکا",
  57: "کلمبیا",
  242: "کنگو",
  254: "کنیا",
  53: "کوبا",
  269: "کومور",
  965: "کویت",
  241: "گابون",
  220: "گامبیا",
  955: "گرجستان",
  1473: "گرنادا",
  502: "گواتمالا",
  671: "گوام",
  224: "گینه",
  240: "گینه استوایی",
  245: "گینه بیسائو",
  856: "لائوس",
  961: "لبنان",
  266: "لسوتو",
  48: "لهستان",
  352: "لوکزامبورگ",
  231: "لیبریا",
  218: "لیبی",
  265: "مالاوی",
  356: "مالت",
  960: "مالدیو",
  60: "مالزی",
  223: "مالی",
  36: "مجارستان",
  212: "مراکش",
  20: "مصر",
  976: "مغولستان",
  389: "مقدونیه",
  222: "موریتانی",
  230: "موریس",
  258: "موزامبیک",
  95: "میانمار",
  52: "مکزیک",
  674: "نائورا",
  264: "نامیبیا",
  977: "نپال",
  47: "نروژ",
  267: "نگارا پرونئی دارالسلام",
  227: "نیجر",
  505: "نیکاراگوئه",
  509: "هائی تی",
  31: "هلند",
  91: "هند",
  504: "هندوراس",
  752: "هنگ کنگ",
  39: "واتیکان",
  58: "ونزوئلا",
  84: "ویتنام",
  969: "یمن جنوبی",
  967: "یمن شمالی",
  381: "یوگسلاوی",
  30: "یونان",
};
const countryList = {
  AF: "افغانستان",
  AL: "آلبانی",
  DZ: "الجزایر",
  AS: "جزایر ساموآ",
  AD: "آندورا",
  AO: "آنگولا",
  AI: "آنگویلا",
  AQ: "جنوبگان",
  AG: "آنتیگوا و باربودا",
  AR: "آرژانتین",
  AM: "ارمنستان",
  AW: "آروبا",
  AU: "استرالیا",
  AT: "اتریش",
  AZ: "آذربایجان",
  BH: "بحرین",
  BD: "بنگلادش",
  BB: "باربادوس",
  BY: "بلاروس",
  BE: "بلژیک",
  BZ: "بلیز",
  BJ: "بنین",
  BM: "برمودا",
  BT: "بوتان",
  BO: "بولیوی",
  BA: "بوسنی و هرزگوین",
  BW: "بوتساوا",
  BV: "جزیره بووه",
  BR: "برزیل",
  IO: "قلمرو اقیانوس هند بریتانیا",
  VG: "جزایر ویرجین بریتانیا",
  BN: "برونئی",
  BG: "بلغارستان",
  BF: "بورکینافاسو",
  BI: "بوروندی",
  CI: "ساحل عاج",
  KH: "کامبوج",
  CM: "کامرون",
  CA: "کانادا",
  CV: "کیپ ورد",
  KY: "جزایر کیمن",
  CF: "جمهوری آفریقای مرکزی",
  TD: "چاد",
  CL: "شیلی",
  CN: "چین",
  CX: "جزیره کریسمس",
  CC: "جرایز کوکوس ( کیلینگ)",
  CO: "کلمبیا",
  KM: "کومور",
  CG: "کنگو",
  CK: "جزایر کوک",
  CR: "کاستاریکا",
  HR: "کرواسی",
  CU: "کوبا",
  CY: "قبرس",
  CZ: "جمهوری چک",
  CD: "جمهوری دموکراتیک کنگو",
  DK: "دانمارک",
  DJ: "جیبوتی",
  DM: "دومینیکا",
  DO: "جمهوری دومینیکن",
  TL: "تیمور شرقی",
  EC: "اکوادور",
  EG: "مصر",
  SV: "السالوادور",
  GQ: "گینه استوایی",
  ER: "اریتره",
  EE: "استونی",
  ET: "اتیوپی",
  FO: "جزایر فارو",
  FK: "جزایر فالکلند",
  FJ: "فیجی",
  FI: "فنلاند",
  MK: "جمهوری مقدونیه یوگسلاوی سابق",
  FR: "فرانسه",
  GF: "گویای فرانسه",
  PF: "پلینزی فرانسه",
  TF: "سرزمین های جنوبی فرانسه",
  GA: "گابن",
  GE: "گرجستان",
  DE: "آلمان",
  GH: "غنا",
  GI: "جبل الطارق",
  GR: "یونان",
  GL: "گرینلند",
  GD: "گرانادا",
  GP: "گوادلوپ",
  GU: "گوام",
  GT: "گواتمالا",
  GN: "گینه",
  GW: "گینه بیسائو",
  GY: "گویان",
  HT: "هائیتی",
  HM: "جزیه هرد و جزایر مک دونالد",
  HN: "هندوراس",
  HK: "هنگ کنگ",
  HU: "مجارستان",
  IS: "ایسلند",
  IN: "هند",
  ID: "اندونزی",
  IR: "ایران",
  IQ: "عراق",
  IE: "ایرلند",
  IL: "اسرائیل",
  IT: "ایتالیا",
  JM: "جامائیکا",
  JP: "ژاپن",
  JO: "اردن",
  KZ: "قزاقستان",
  KE: "کنیا",
  KI: "کیریباتی",
  KW: "کویت",
  KG: "قرقیزستان",
  LA: "لائوس",
  LV: "لتونی",
  LB: "لبنان",
  LS: "لسوتو",
  LR: "لیبریا",
  LY: "لیبی",
  LI: "لیختن اشتاین",
  LT: "لیتوانی",
  LU: "لوکزامبورگ",
  MO: "ماکائو",
  MG: "ماداگاسکار",
  MW: "مالاوی",
  MY: "مالزی",
  MV: "مالدیو",
  ML: "مالی",
  MT: "مالت",
  MH: "جزایر مارشال",
  MQ: "مارتینیک",
  MR: "موریتانی",
  MU: "موریس",
  YT: "مایوت",
  MX: "مکزیک",
  FM: "میکرونزی",
  MD: "مولداوی",
  MC: "موناکو",
  MN: "مغولستان",
  MS: "مونتسرات",
  MA: "مراکش",
  MZ: "موزامبیک",
  MM: "میانمار",
  NA: "نامیبیا",
  NR: "نائورو",
  NP: "نپال",
  NL: "هلند",
  AN: "آنتیل هلند",
  NC: "کالدونیای جدید",
  NZ: "نیوزیلند",
  NI: "نیکاروگوئه",
  NE: "نبجر",
  NG: "نیجریه",
  NU: "نیوئه",
  NF: "جزیره نورفولک",
  KP: "کره شمالی",
  MP: "ماریانای شمالی",
  NO: "نروژ",
  OM: "عمان",
  PK: "پاکستان",
  PW: "پالائو",
  PA: "پاناما",
  PG: "پاپوآ گینه نو",
  PY: "پاراگوئه",
  PE: "پرو",
  PH: "فیلیپین",
  PN: "جزایر پیتکرن",
  PL: "لهستان",
  PT: "کشور پرتغال",
  PR: "پورتوریکو",
  QA: "قطر",
  RE: "رئونیون",
  RO: "رومانی",
  RU: "روسیه",
  RW: "رواندا",
  ST: "سائوتومه و پرنسیپ",
  SH: "سنت هلنا",
  KN: "سنت کیتس و نویس",
  LC: "سنت لوسیا",
  PM: "سنت پیر و میکلون",
  VC: "سنت وینسنت و گرنادین ها",
  WS: "ساموآ",
  SM: "سن مارینو",
  SA: "عربستان سعودی",
  SN: "سنگال",
  SC: "سیشل",
  SL: "سیرا لئون",
  SG: "سنگاپور",
  SK: "اسلواکی",
  SI: "اسلوونی",
  SB: "جزایر سلیمان",
  SO: "سومالی",
  ZA: "آفریقای جنوبی",
  GS: "جورجیا جنوبی و جزایر ساندویج جنوبی",
  KR: "کره جنوبی",
  ES: "اسپانیا",
  LK: "سریلانکا",
  SD: "سودان",
  SR: "سورینام",
  SJ: "سوالبارد و یان ماین",
  SZ: "سوازیلند",
  SE: "سوئد",
  CH: "سوئیس",
  SY: "سوریه",
  TW: "تایوان",
  TJ: "تاجیکستان",
  TZ: "تانزانیا",
  TH: "تایلند",
  BS: "باهاماس",
  GM: "گامبیا",
  TG: "توگو",
  TK: "توکلائو",
  TO: "تونگا",
  TT: "ترینیداد و توباگو",
  TN: "تونس",
  TR: "ترکیه",
  TM: "ترکمنستان",
  TC: "جزایر تورکس و کایکوس",
  TV: "تووالو",
  VI: "جزایر ویرجین ایالات متحده",
  UG: "اوگاندا",
  UA: "اوکراین",
  AE: "امارات متحده عربی",
  UK: "انگستان",
  US: "ایالات متحده آمریکا",
  UM: "جزایر کوچک حاشیه ای ایالات متحده",
  UY: "اروگوئه",
  UZ: "ازبکستان",
  VU: "وانواتو",
  VA: "شهر واتیکان",
  VE: "ونزوئلا",
  VN: "ویتنام",
  WF: "والیس و فوتونا",
  EH: "صحرای غربی",
  YE: "یمن",
  YU: "یوگسلاوی",
  ZM: "زامبیا",
  ZW: "زیمبابوه",
};
const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
const provinceList = {
  1: "آذربایجان‌شرقی",
  2: "آذربایجان‌غربی",
  3: "اردبیل",
  4: "اصفهان",
  5: "البرز",
  6: "ایلام",
  7: "بوشهر",
  8: "تهران",
  9: "چهارمحال‌و‌بختیاری",
  10: "خراسان‌جنوبی",
  11: "خراسان‌رضوی",
  12: "خراسان‌شمالی",
  13: "خوزستان",
  14: "زنجان",
  15: "سمنان",
  16: "سیستان‌و‌بلوچستان",
  17: "فارس",
  18: "قزوین",
  19: "قم",
  20: "كردستان",
  21: "كرمان ",
  22: "كرمانشاه",
  23: "کهگیلویه‌و‌بویراحمد",
  24: "گلستان",
  25: "گیلان",
  26: "لرستان",
  27: "مازندران",
  28: "مركزی",
  29: "هرمزگان",
  30: "همدان",
  31: "یزد",
};
const citiesList = {
  1: {
    1: "اسکو",
    2: "اهر",
    3: "آذرشهر",
    4: "بستان آباد",
    5: "بناب",
    6: "تبریز",
    7: "جلفا",
    8: "چاراویماق",
    9: "خداآفرین",
    10: "سراب",
    11: "شبستر",
    12: "عجب شیر",
    13: "کلیبر",
    14: "مراغه",
    15: "مرند",
    16: "ملکان",
    17: "میانه",
    18: "ورزقان",
    19: "هریس",
    20: "هشترود",
  },
  2: {
    1: "ارومیه",
    2: "اشنویه",
    3: "بوكان",
    4: "پلدشت",
    5: "پیرانشهر",
    6: "تكاب",
    7: "چالدران",
    8: "چایپاره",
    9: "خوئ",
    10: "سردشت",
    11: "سلماس",
    12: "شاهین دژ",
    13: "شوط",
    14: "ماكو",
    15: "مهاباد",
    16: "میاندوآب",
    17: "نقده",
  },
  3: {
    1: "اردبیل",
    2: "بیله سوار",
    3: "پارس آباد",
    4: "خلخال",
    5: "سرعین",
    6: "كوثر",
    7: "گرمی",
    8: "مشگین شهر",
    9: "نمین",
    10: "نیر",
  },
  4: {
    1: "اردستان",
    2: "اصفهان",
    3: "آران وبیدگل",
    4: "برخوار",
    5: "بو یین و میاندشت",
    6: "تیران وکرون",
    7: "چادگان",
    8: "خمینی شهر",
    9: "خوانسار",
    10: "خور و بیابانک",
    11: "دهاقان",
    12: "سمیرم",
    13: "شاهین شهرومیمه",
    14: "شهرضا",
    15: "فریدن",
    16: "فریدونشهر",
    17: "فلاورجان",
    18: "کاشان",
    19: "گلپایگان",
    20: "لنجان",
    21: "مبارکه",
    22: "نایین",
    23: "نجف آباد",
    24: "نطنز",
  },
  5: {
    1: "اشتهارد",
    2: "ساوجبلاغ",
    3: "طالقان",
    4: "فردیس",
    5: "کرج",
    6: "نظرآباد",
  },
  6: {
    1: "ایلام",
    2: "ایوان",
    3: "آبدانان",
    4: "بدره",
    5: "چرداول",
    6: "دره شهر",
    7: "دهلران",
    8: "سیروان",
    9: "ملكشاهی",
    10: "مهران",
  },
  7: {
    1: "بوشهر",
    2: "تنگستان",
    3: "جم",
    4: "دشتستان",
    5: "دشتی",
    6: "دیر",
    7: "دیلم",
    8: "عسلویه",
    9: "كنگان",
    10: "گناوه",
  },
  8: {
    1: "اسلامشهر",
    2: "بهارستان",
    3: "پاكدشت",
    4: "پردیس",
    5: "پیشوا",
    6: "تهران",
    7: "دماوند",
    8: "رباطكریم",
    9: "رئ",
    10: "شمیرانات",
    11: "شهریار",
    12: "فیروزكوه",
    13: "قدس",
    14: "قرچک",
    15: "ملارد",
    16: "ورامین",
  },
  9: {
    1: "اردل",
    2: "بروجن",
    3: "بن",
    4: "سامان",
    5: "شهركرد",
    6: "فارسان",
    7: "كوهرنگ",
    8: "كیار",
    9: "لردگان",
  },
  10: {
    1: "بشرویه",
    2: "بیرجند",
    3: "خوسف",
    4: "درمیان",
    5: "زیرکوه",
    6: "سرایان",
    7: "سربیشه",
    8: "طبس",
    9: "فردوس",
    10: "قائنات",
    11: "نهبندان",
  },
  11: {
    1: "باخرز",
    2: "بجستان",
    3: "بردسكن",
    4: "بینالود",
    5: "تایباد",
    6: "تربت جام",
    7: "تربت حیدریه",
    8: "جغتای",
    9: "جوین",
    10: "چناران",
    11: "خلیل آباد",
    12: "خواف",
    13: "خوشاب",
    14: "داورزن",
    15: "درگز",
    16: "رشتخوار",
    17: "زاوه",
    18: "سبزوار",
    19: "سرخس",
    20: "فریمان",
    21: "فیروزه",
    22: "قوچان",
    23: "كاشمر",
    24: "كلات",
    25: "گناباد",
    26: "مشهد",
    27: "مه ولات",
    28: "نیشابور",
  },
  12: {
    1: "اسفراین",
    2: "بجنورد",
    3: "جاجرم",
    4: "راز و جرگلان",
    5: "شیروان",
    6: "فاروج",
    7: "گرمه",
    8: "مانه وسملقان",
  },
  13: {
    1: "امیدیه",
    2: "اندیکا",
    3: "اندیمشک",
    4: "اهواز",
    5: "ایذه",
    6: "آبادان",
    7: "آغاجاری",
    8: "باغ ملک",
    9: "باوی",
    10: "بندرماهشهر",
    11: "بهبهان",
    12: "حمیدیه",
    13: "خرمشهر",
    14: "دزفول",
    15: "دشت آزادگان",
    16: "رامشیر",
    17: "رامهرمز",
    18: "شادگان",
    19: "شوش",
    20: "شوشتر",
    21: "کارون",
    22: "گتوند",
    23: "لالی",
    24: "مسجدسلیمان",
    25: "هفتگل",
    26: "هندیجان",
    27: "هویزه",
  },
  14: {
    1: "ابهر",
    2: "ایجرود",
    3: "خدابنده",
    4: "خرمدره",
    5: "زنجان",
    6: "سلطانیه",
    7: "طارم",
    8: "ماهنشان",
  },
  15: {
    1: "آرادان",
    2: "دامغان",
    3: "سرخه",
    4: "سمنان",
    5: "شاهرود",
    6: "گرمسار",
    7: "مهدئ شهر",
    8: "میامی",
  },
  16: {
    1: "ایرانشهر",
    2: "چاه بهار",
    3: "خاش",
    4: "دلگان",
    5: "زابل",
    6: "زاهدان",
    7: "زهك",
    8: "سراوان",
    9: "سرباز",
    10: "سیب و سوران",
    11: "فنوج",
    12: "قصرقند",
    13: "كنارك",
    14: "مهرستان",
    15: "میرجاوه",
    16: "نیك شهر",
    17: "نیمروز",
    18: "هامون",
    19: "هیرمند",
  },
  17: {
    1: "ارسنجان",
    2: "استهبان",
    3: "اقلید",
    4: "آباده",
    5: "بوانات",
    6: "پاسارگاد",
    7: "جهرم",
    8: "خرامه",
    9: "خرم بید",
    10: "خنج",
    11: "داراب",
    12: "رستم",
    13: "زرین دشت",
    14: "سپیدان",
    15: "سروستان",
    16: "شیراز",
    17: "فراشبند",
    18: "فسا",
    19: "فیروزآباد",
    20: "قیروکارزین",
    21: "کازرون",
    22: "کوار",
    23: "گراش",
    24: "لارستان",
    25: "لامرد",
    26: "مرودشت",
    27: "ممسنی",
    28: "مهر",
    29: "نی ریز",
  },
  18: {
    1: "البرز",
    2: "آبیك",
    3: "آوج",
    4: "بوئین زهرا",
    5: "تاكستان",
    6: "قزوین",
  },
  19: { 1: "قم" },
  20: {
    1: "بانه",
    1: "بیجار",
    1: "دهگلان",
    1: "دیواندره",
    1: "سروآباد",
    1: "سقز",
    1: "سنندج",
    1: "قروه",
    1: "كامیاران",
    1: "مریوان",
  },
  21: {
    1: "ارزوئیه",
    2: "انار",
    3: "بافت",
    4: "بردسیر",
    5: "بم",
    6: "جیرفت",
    7: "رابر",
    8: "راور",
    9: "رفسنجان",
    10: "رودبارجنوب",
    11: "ریگان",
    12: "زرند",
    13: "سیرجان",
    14: "شهربابك",
    15: "عنبرآباد",
    16: "فاریاب",
    17: "فهرج",
    18: "قلعه گنج",
    19: "كرمان",
    20: "كوهبنان",
    21: "كهنوج",
    22: "منوجان",
    23: "نرماشیر",
  },
  22: {
    1: "اسلام آبادغرب",
    2: "پاوه",
    3: "ثلاث باباجانی",
    4: "جوانرود",
    5: "دالاهو",
    6: "روانسر",
    7: "سرپل ذهاب",
    8: "سنقر",
    9: "صحنه",
    10: "قصرشیرین",
    11: "کرمانشاه",
    12: "کنگاور",
    13: "گیلانغرب",
    14: "هرسین",
  },
  23: {
    1: "باشت",
    2: "بویراحمد",
    3: "بهمئی",
    4: "چرام",
    5: "دنا",
    6: "كهگیلویه",
    7: "گچساران",
    8: "لنده",
  },
  24: {
    1: "آزادشهر",
    2: "آق قلا",
    3: "بندرگز",
    4: "تركمن",
    5: "رامیان",
    6: "علی آباد",
    7: "كردكوئ",
    8: "كلاله",
    9: "گالیكش",
    10: "گرگان",
    11: "گمیشان",
    12: "گنبدكاووس",
    13: "مراوه تپه",
    14: "مینودشت",
  },
  25: {
    1: "املش",
    2: "آستارا",
    3: "آستانه اشرفیه",
    4: "بندرانزلی",
    5: "رشت",
    6: "رضوانشهر",
    7: "رودبار",
    8: "رودسر",
    9: "سیاهكل",
    10: "شفت",
    11: "صومعه سرا",
    12: "طوالش",
    13: "فومن",
    14: "لاهیجان",
    15: "لنگرود",
    16: "ماسال",
  },
  26: {
    1: "ازنا",
    2: "الیگودرز",
    3: "بروجرد",
    4: "پلدختر",
    5: "خرم آباد",
    6: "دلفان",
    7: "دورود",
    8: "دوره",
    9: "رومشکان",
    10: "سلسله",
    11: "کوهدشت",
  },
  27: {
    1: "آمل",
    2: "بابل",
    3: "بابلسر",
    4: "بهشهر",
    5: "تنكابن",
    6: "جویبار",
    7: "چالوس",
    8: "رامسر",
    9: "سارئ",
    10: "سوادکوه شمالی",
    11: "سوادكوه",
    12: "سیمرغ",
    13: "عباس آباد",
    14: "فریدونكنار",
    15: "قائم شهر",
    16: "کلاردشت",
    17: "گلوگاه",
    18: "محمودآباد",
    19: "میاندورود",
    20: "نكا",
    21: "نور",
    22: "نوشهر",
  },
  28: {
    1: "اراک",
    2: "آشتیان",
    3: "تفرش",
    4: "خمین",
    5: "خنداب",
    6: "دلیجان",
    7: "زرندیه",
    8: "ساوه",
    9: "شازند",
    10: "فراهان",
    11: "کمیجان",
    12: "محلات",
  },
  29: {
    1: "ابوموسی",
    2: "بستك",
    3: "بشاگرد",
    4: "بندرعباس",
    5: "بندرلنگه",
    6: "پارسیان",
    7: "جاسك",
    8: "حاجی اباد",
    9: "خمیر",
    10: "رودان",
    11: "سیریك",
    12: "قشم",
    13: "میناب",
  },
  30: {
    1: "اسدآباد",
    2: "بهار",
    3: "تویسركان",
    4: "رزن",
    5: "فامنین",
    6: "كبودرآهنگ",
    7: "ملایر",
    8: "نهاوند",
    9: "همدان",
  },
  31: {
    1: "ابركوه",
    2: "اردكان",
    3: "اشکذر",
    4: "بافق",
    5: "بهاباد",
    6: "تفت",
    7: "خاتم",
    8: "مهریز",
    9: "میبد",
  },
};
